import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";

export const Services = (props) => {
  const servicesRef = useRef(null);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (servicesRef.current) {
        const rect = servicesRef.current.getBoundingClientRect();
        setIsActive(rect.top <= 200);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div id="services" className="text-center" ref={servicesRef}>
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
          <p>
            From software development to UI/UX design, data processing, cybersecurity, and more, our diverse range of services is tailored to meet your every need. With a commitment to excellence and a focus on efficiency, we provide dynamic solutions that drive business success.
          </p>
          <p>
            Let us be your trusted partner on the journey to achieving your goals.
          </p>
        </div>
        <div style={{ overflow: "hidden" }} className="row">
          {props.data
            ? props.data.map((d, i) => {
                const slideDir = i % 2 === 0 ? 'services-from-left' : 'services-from-right';
                return (
                  <div
                    key={`${d.name}-${i}`}
                    className={`row services ${slideDir} ${isActive ? 'services-active' : ''}`}
                    style={{ transitionDelay: isActive ? `${i * 0.15}s` : '0s' }}
                  >
                    <div className="service-desc col-md-6 col-xs-12">
                      <h3>{d.name}</h3>
                      <p>{d.text}</p>
                      <Link onClick={() => scroll.scrollToTop()} to={`/services/${d.slug}`}><button className="">LEARN MORE</button></Link>
                    </div>
                    <div className="col-md-6 col-xs-12 image">
                      <img src={d.image} alt={d.name} loading="lazy" decoding="async" />
                    </div>
                  </div>
                );
              })
            : "loading"}
        </div>
      </div>
    </div>
  );
};
